<template>
  <div class="page_summary">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="flex">
          <div class="exactDate flex aic">
            <div class="flname" style="margin-right:5px;">
              归属{{ pageType == "year" ? "年" : "月" }}份:
            </div>
            <div class="block" v-if="pageType == 'month'">
              <el-date-picker
                v-model="listQuery.belongMonthstart"
                type="month"
                :picker-options="pickerOptions"
                value-format="yyyy-MM"
                placeholder="开始月份"
              >
              </el-date-picker>
              <span style="margin: 0 5px; display: inline-block">-</span>
              <el-date-picker
                v-model="listQuery.belongMonthend"
                type="month"
                :picker-options="pickerOptionEnd"
                value-format="yyyy-MM"
                placeholder="结束月份"
              >
              </el-date-picker>
            </div>
            <div class="block" v-if="pageType == 'year'">
              <el-date-picker
                v-model="listQuery.belongMonthstart"
                type="year"
                :picker-options="pickerOptions"
                value-format="yyyy"
                placeholder="开始年份"
              >
              </el-date-picker>
              <span style="margin: 0 5px; display: inline-block">-</span>
              <el-date-picker
                v-model="listQuery.belongMonthend"
                type="year"
                :picker-options="pickerOptionEndYear"
                value-format="yyyy"
                placeholder="结束年份"
              >
              </el-date-picker>
            </div>
          </div>
          <button
            class="exportButton"
            style="margin-left: 5px"
            @click="getImprtInfo"
          >
            搜索
          </button>
        </div>
      </div>
      <div class="top-right" style="margin-right: 30px">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>
      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen == 1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>团队长</div>
            <el-select
              v-model="listQuery.strleader"
              filterable
              remote
              reserve-keyword
              placeholder="请输入团队长"
              @focus="remoteFocus('strleader')"
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>业绩归属人</div>
            <el-select
              v-model="listQuery.strdirector"
              filterable
              remote
              reserve-keyword
              placeholder="请输入业绩归属人"
              @focus="remoteFocus('strdirector')"
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select
              v-model="listQuery.strSrvCent"
              filterable
              remote
              reserve-keyword
              placeholder="请输入服务中心"
              @focus="remoteFocus('strSrvCent')"
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>项目名称</div>
            <el-select
              v-model="listQuery.strObjName"
              filterable
              remote
              reserve-keyword
              placeholder="请输入项目名称"
              @focus="remoteFocus('strObjName')"
              :remote-method="remoteMethod"
              :loading="searchLoading"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div v-if="pageType == 'month'" class="p_field_box formScreenInput">
            <div>报表字段</div>
            <el-checkbox-group v-model="checkList" @change="checkChange">
              <el-checkbox v-for="item in checkFieldList" :label="item.StrColumId" :key="item.StrColumName">{{item.StrColumName}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right: 10px" @click="clear()">
            清空
          </button>
          <button class="search" @click="searchHandle">搜索</button>
          <button class="clear" @click="showDropScreen = -1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务数据源汇总</el-breadcrumb-item>
          <el-breadcrumb-item
            >{{ pageType == "year" ? "年" : "月" }}报</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable">
        <div class="dlt_btn">
          <el-button
            type="success"
            plain
            size="mini"
            @click="exportHandle"
            :loading="exportLoading"
            v-if="isCanHandle && (tableData.length > 0 && !isNull(tableData))"
            >导出</el-button
          >
        </div>
      </div>
      <div class="sum_search_box" v-if="listQuery.strleader||listQuery.strdirector||listQuery.strSrvCent||listQuery.strObjName||checkList.length>0">
        <div class="txt01">搜索条件:</div>
        <div class="sum_search_content">
          <div v-if="listQuery.strleader" class="sum_search_item">团队长: {{listQuery.strleader}}，</div>
          <div v-if="listQuery.strdirector" class="sum_search_item">业绩归属人: {{listQuery.strdirector}}，</div>
          <div v-if="listQuery.strSrvCent" class="sum_search_item">服务中心: {{listQuery.strSrvCent}}，</div>
          <div v-if="listQuery.strObjName" class="sum_search_item">项目名称: {{listQuery.strObjName}}，</div>
          <div v-if="searchCheckNameList" class="sum_search_item">
            <span>报表字段：{{searchCheckNameList}} 。</span>
          </div>
        </div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="财务数据源列表" name="first"></el-tab-pane>
        <el-tab-pane label="财务数据源月报" name="second"></el-tab-pane>
        <el-tab-pane label="财务数据源年报" name="third"></el-tab-pane>
      </el-tabs>
      <div class="annualChannelTable">
        <el-table
          ref="reportTable"
          :data="tableData"
          :max-height="tableHeight - 180"
          v-loading="listLoading"
          element-loading-text="报表生成中"
          element-loading-spinner="el-icon-loading"
          style="width: 99%"
        >
          <el-table-column label="" :width="(dataTitle.length > 0) ?'400px':'auto'" :fixed="(dataTitle.length > 0) ? true : false">
            <template v-for="(item, index) in fixedTitle">
              <el-table-column
                :prop="item.StrColumId"
                :label="item.StrColumName"
                :key="index"
                align="center"
                :width="(dataTitle.length > 0) ?'100px':'auto'"
                :fixed="(dataTitle.length > 0) ? true : false"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.cus[item.StrColumId] }}</div>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
          <template v-for="(items, index) in tableTitle">
            <el-table-column v-if="dataTitle && dataTitle.length>0" :label="items.strMonth" :key="index" align="center">
              <template v-for="(item, tIndex) in items.dataTitle">
                <el-table-column
                  :prop="item.StrColumId"
                  min-width="130px"
                  :key="tIndex"
                  :label="item.StrColumName"
                  fit
                  align="center"
                >
                  <template slot-scope="scope">
                    <div v-if="!isNull(scope.row.detailslist[index].pricedetail[item.StrColumId]) && item.StrColumId != 'Profit'" style="cursor: pointer;color:#409EFF;" @click="jumpDetail(scope.row.cus, scope.row.detailslist[index], item.StrColumName)">{{ scope.row.detailslist[index] ? scope.row.detailslist[index].pricedetail[item.StrColumId] :'' }}</div>
                    <div v-else>{{ scope.row.detailslist ? scope.row.detailslist[index].pricedetail[item.StrColumId] :'' }}</div>
                  </template>
                </el-table-column>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="Number(totalcount) > 0" style="width: 99%">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pagecount"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "../../common";
import moment from 'moment'
import { parseTime } from "../../utils"; // 格式化时间格式
export default {
  name: "financialSummary",
  data() {
    return {
      listLoading: false,
      exportLoading: false,
      //下拉筛选
      showDropScreen: -1,
      //列表参数
      listQuery: {
        pagecount: 10,
        currpage: 1,
        straccountname: "", // 账户名
        strleader: "", // 团队长
        strdirector: "", // 负责人 业绩归属人
        strarea: "", // 区域
        strdepartment: "", // 部门
        strSrvCent: "", // 服务中心
        strObjName: "", // 项目
        strClass: "", // 分类
        strType: "月", // 年 月
        belongMonthstart: moment().subtract(1, 'month').format('YYYY-MM'), // 归属月 开始
        belongMonthend: moment().subtract(1, 'month').format('YYYY-MM') // 归属月 结束
      },
      //导出参数
      exportQuery: {
        pagecount: 100000000,
        currpage: 1,
        straccountname: "", // 账户名
        strleader: "", // 团队长
        strdirector: "", // 负责人
        strarea: "", //区域
        strdepartment: "", // 部门
        strSrvCent: "", //服务中心
        strObjName: "", // 项目
        strType: "月", // 年 月
        strClass: "", // 分类
        belongMonthstart: "", //归属月 开始
        belongMonthend: "", // 归属月 结束
        strdisplay: "" // 选中的字段 多个逗号隔开
      },
      tableData: [],
      totalcount: 0,
      // 筛选参数
      searchQuery: {
        pagecount: 100000,
        currpage: 1,
        type: "",
        keyword: "",
      },
      // 筛选里的搜索列表
      options: [],
      activeName: "second",
      // 页面类型 month(月报) year(年报)
      pageType: "month",
      // 禁用日期范围
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptionEnd: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptionEndYear: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      // 表格高度
      tableHeight: 0,
      searchLoading: false,
      // 非固定表头
      tableTitle: [],
      // 固定表头
      fixedTitle: [
        {
          StrColumName: "服务中心",
          StrColumId: "StrSrvCent"
        },
        {
          StrColumName: "团队长",
          StrColumId: "Strleader"
        },
        {
          StrColumName: "业绩归属人",
          StrColumId: "Strdirector"
        },
        {
          StrColumName: "项目",
          StrColumId: "StrObjName"
        }
      ],
      // 每月固定二级表头
      dataTitle: [],
      // 表头日期数组
      dateTitle:[moment().subtract(1, 'month').format('YYYY-MM')],
      // 报表可选字段
      checkFieldList: [{
          StrColumName: "项目收入",
          StrColumId: "Projectincome"
        },{
          StrColumName: "返税收入",
          StrColumId: "Rebateincome"
        },
        {
          StrColumName: "工伤收入",
          StrColumId: "Injuryincome"
        },
        {
          StrColumName: "生育收入",
          StrColumId: "Fertincome"
        },
        {
          StrColumName: "其他收入",
          StrColumId: "Otherincome"
        },
        {
          StrColumName: "成本",
          StrColumId: "Costexpend"
        },
        {
          StrColumName: "招聘费用",
          StrColumId: "Recruitexpend"
        },
        {
          StrColumName: "工伤",
          StrColumId: "Injuryexpend"
        },
        {
          StrColumName: "生育",
          StrColumId: "Fertexpend"
        },
        {
          StrColumName: "其他费用",
          StrColumId: "Otherexpend"
        },
        {
          StrColumName: "利润",
          StrColumId: "Profit"
      }],
      // 选中的字段
      checkList: [],
      // 筛选条件选中的报表字段
      searchCheckList:[],
      // 筛选条件选中的报表字段名称
      searchCheckNameList:'',
      // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'employee-fnnclst'
        },
        // 是否有权限操作按钮
        isCanHandle:false
    }
  },
  async created() {
    this.butQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
    this.pageType = this.$route.query.type
    this.calHeight()
    // 开始日期与结束日期不能超过12个月(月报)
    if (this.pageType == "month") {
      this.activeName = "second"
      this.listQuery.strType = "月"
      this.listQuery.belongMonthstart = moment().subtract(1, 'month').format('YYYY-MM')
      this.listQuery.belongMonthend = moment().subtract(1, 'month').format('YYYY-MM')
      this.pickerOptionEnd.disabledDate = (time) => {
        let disabledTime =
          (time.getTime() <
            new Date(
              new Date(this.listQuery.belongMonthstart).getFullYear(),
              new Date(this.listQuery.belongMonthstart).getMonth()
            )) ||
          (time.getTime() >
            new Date(
              new Date(this.listQuery.belongMonthstart).getFullYear() + 1,
              new Date(this.listQuery.belongMonthstart).getMonth() - 1
            )) ||
          (Date.now() < time.getTime());
        return disabledTime;
      };
      this.dataTitle = []
    }
    // 开始日期与结束日期不能超过5年(年报)
    if (this.pageType == "year") {
      this.activeName = "third"
      this.listQuery.strType = "年"
      this.listQuery.belongMonthstart = parseTime(new Date(), "{y}")
      this.listQuery.belongMonthend = parseTime(new Date(), "{y}")
      this.dataTitle = [{
          StrColumName: "利润",
          StrColumId: "Profit"
        }]
      this.pickerOptionEndYear.disabledDate = (time) => {
        let disabledTime =
          time.getTime() < new Date(new Date(this.listQuery.belongMonthstart).getFullYear(), new Date(this.listQuery.belongMonthstart).getMonth())
          || time.getTime() > new Date(new Date(this.listQuery.belongMonthstart).getFullYear()+5, new Date(this.listQuery.belongMonthstart).getMonth() - 1)
          || Date.now() < time.getTime()
        return disabledTime;
      };
    }
    await this.getImprtInfo();
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      if (tab.name == "first") {
        this.$router.push({ path: "/financialSource" });
      }
      if (tab.name == "third") {
        this.listQuery.belongMonthstart = parseTime(new Date(), "{y}")
        this.listQuery.belongMonthend = parseTime(new Date(), "{y}")
        this.listQuery.strType = "年";
        this.pageType = "year";
        this.dataTitle = [{
          StrColumName: "利润",
          StrColumId: "Profit"
        }]
        this.$router.push({
          path: "/financialSummary",
          query: { type: "year" },
        });
        this.getImprtInfo();
      }
      if (tab.name == "second") {
        // 默认全选字段
        this.checkList = []
        // this.checkList = ['Fertincome', 'Otherincome', 'Costexpend', 'Recruitexpend', 'Injuryexpend', 'Otherexpend', 'Fertexpend', 'Profit', 'Injuryincome', 'Rebateincome', 'Projectincome']
        this.dataTitle = []
        this.listQuery.belongMonthstart = moment().subtract(1, 'month').format('YYYY-MM')
        this.listQuery.belongMonthend = moment().subtract(1, 'month').format('YYYY-MM')
        this.listQuery.strType = "月";
        this.pageType = "month";
        this.$router.push({
          path: "/financialSummary",
          query: { type: "month" }
        });
        this.getImprtInfo();
      }
    },
    // 筛选
    searchHandle(){
      let checkArr = []
      // 获取选中的报表字段
      this.searchCheckList = this.checkFieldList.filter(item=>{
            return this.checkList.includes(item.StrColumId)
      })
      for (let i = 0; i < this.searchCheckList.length; i++) {
        const elementCheck = this.searchCheckList[i]
        checkArr.push(elementCheck.StrColumName)
      }
      this.searchCheckNameList = checkArr.toString()
      // console.log('val', this.searchCheckList)
      this.getImprtInfo()
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let powerVal  = res.msg[0].Buttons
          if(powerVal == 'search'){
            // 只能查看
            this.isCanHandle = false
          }else if(powerVal == 'update'){
            // 特殊处理 只能更改客服
            this.isCanHandle = false
          }else if(powerVal == 'operation'){
            // 可操作
            this.isCanHandle = true
          }
        }else{
          this.isCanHandle = false
        }
      })
    },
    // 修改复选框字段
    checkChange(val){
      // console.log('val', val)
      this.checkList = val
      // console.log('checkList', this.dataTitle)
    },
    // 跳转数据源列表
    jumpDetail(item, dtlItem, strClass){
      // console.log('kkk', item, strClass)
      let routeUrl = this.$router.resolve({ path: '/employee-financialSource', query: {
          strleader: item.Strleader,
          strdirector: item.Strdirector,
          strSrvCent: item.StrSrvCent,
          strObjName: item.StrObjName,
          strClass: strClass,
          belongMonthstart: dtlItem.strMonth,
          belongMonthend: dtlItem.strMonth
        }
      });
      window.open(routeUrl.href, '_blank');
    },
    //获取花名册信息
    getImprtInfo() {
      this.tableTitle = []
      this.dateTitle = []
      this.listLoading = true;
      // console.log("gg", this.tableTitle);
      if (this.pageType == "month") {
        this.dataTitle = []
        this.dataTitle = this.checkFieldList.filter(item => this.checkList.includes(item.StrColumId))
      }else{
        this.dataTitle = [{
          StrColumName: "利润",
          StrColumId: "Profit"
        }]
      }
      xz.getFinanceSourceStatistics(this.listQuery)
        .then((res) => {
          // console.log("jj", res);
          if (res.msg && res.msg.length > 0) {
            for (let j = 0; j < res.msg[0].detailslist.length; j++) {
              const elemendate = res.msg[0].detailslist[j];
              this.dateTitle.push(elemendate.strMonth)
            }
            res.msg.forEach((l) => {
              if (!this.isNull(l.StrIdCard) && l.StrIdCard.indexOf("-") > -1) {
                let arr = l.StrIdCard.split("-");
                l["StrIdCard"] = arr[0];
              }
            });
            for (let i = 0; i < this.dateTitle.length; i++) {
              const dateElement = this.dateTitle[i];
              this.tableTitle.push(
                {
                  strMonth: dateElement,
                  dataTitle: this.dataTitle
                }
              )
            }
            this.tableData = res.msg;
            this.totalcount = parseInt(res.totalcount);
          } else {
            // 默认当月表头
            // 去重
            this.dateTitle =  [...new Set(this.yymmDate(this.listQuery.belongMonthstart, this.listQuery.belongMonthend))]
            for (let i = 0; i < this.dateTitle.length; i++) {
              const dateElement = this.dateTitle[i];
              this.tableTitle.push(
                {
                  strMonth: dateElement,
                  dataTitle: this.dataTitle
                }
              )
            }
            this.tableData = [];
            this.totalcount = 0;
          }
          // console.log("jj", this.tableTitle);
          this.listLoading = false;
          this.showDropScreen = -1;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    //翻页
    handleCurrentChange(val) {
      this.listQuery.currpage = Number(val);
      this.getImprtInfo();
    },
    //改变列表加载数量
    handleSizeChange(val) {
      this.listQuery.currpage = 1;
      this.listQuery.pagecount = Number(val);
      this.getImprtInfo();
    },
    //导出
    exportHandle() {
      this.exportQuery.straccountname = this.listQuery.straccountname;
      this.exportQuery.strleader = this.listQuery.strleader;
      this.exportQuery.strdirector = this.listQuery.strdirector;
      this.exportQuery.strarea = this.listQuery.strarea;
      this.exportQuery.strdepartment = this.listQuery.strdepartment;
      this.exportQuery.strSrvCent = this.listQuery.strSrvCent;
      this.exportQuery.strObjName = this.listQuery.strObjName;
      this.exportQuery.strClass = this.listQuery.strClass;
      this.exportQuery.belongMonthend = this.listQuery.belongMonthend;
      this.exportQuery.belongMonthstart = this.listQuery.belongMonthstart;
      this.exportQuery.strType = this.listQuery.strType;
      if (this.pageType == "month") {
         this.exportQuery.strdisplay = this.checkList.toString();
      }
      // console.log('dd', this.exportQuery)
      if (
        this.isNull(this.listQuery.belongMonthstart) ||
        this.isNull(this.listQuery.belongMonthend)
      ) {
        this.$message({
          showClose: true,
          message: "请选择归属日期",
          type: "warning",
        });
        return false;
      } else {
        this.exportLoading = true;
        xz.financeSourcereport(this.exportQuery).then((res) => {
          // console.log('process', res)
          if (res.status == "ok") {
            this.$router.push({
              path: "/employee-fnnchis",
              query: {
                showPage: 1,
                isActive: 1,
                custname: res.msg,
                //qStstus=1时查看最后一条导出记录
                qStstus: 1,
              },
            });
          } else {
            this.$message({
              message: "导出错误，请稍后再试",
              type: "error",
            });
          }
          this.exportLoading = false;
        });
      }
    },
    // 筛选弹框
    dropDownScreen() {
      if (this.showDropScreen == -1) {
        this.showDropScreen = 1;
      } else if (this.showDropScreen == 1) {
        this.showDropScreen = -1;
      }
    },
    //获取表格高度
    calHeight() {
      this.tableHeight = Number(document.documentElement.clientHeight);
      //   console.log('height', this.tableHeight)
    },
    remoteFocus(type) {
      this.searchQuery.type = type;
    },
    async remoteMethod(query) {
      this.searchQuery.keyword = query;
      await this.getSearchList();
      if (query !== "") {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
        }, 300);
      } else {
        this.options = [];
      }
    },
    //清空
    clear() {
      this.listQuery.straccountname = "";
      this.listQuery.strleader = "";
      this.listQuery.strdirector = "";
      this.listQuery.strarea = "";
      this.listQuery.strdepartment = "";
      this.listQuery.strSrvCent = "";
      this.listQuery.strObjName = "";
      this.listQuery.strClass = "";
      this.checkList = []
      this.listQuery.belongMonthstart = moment().subtract(1, 'month').format('YYYY-MM');
      this.listQuery.belongMonthstart = moment().subtract(1, 'month').format('YYYY-MM');
    },
    // 筛选条件
    getSearchList() {
      let searchSelList = [];
      this.resultList = [];
      this.options = [];
      xz.getScreenData(this.searchQuery)
        .then((res) => {
          // console.log('sss',res)
          if (!this.isNull(res.msg)) {
            for (let i = 0; i < res.msg.length; i++) {
              const elements = res.msg[i];
              searchSelList.push({
                value: elements.Keyword,
                label: elements.Keyword,
              });
            }
          }
          this.resultList = searchSelList;
          this.options = searchSelList;
          // console.log('wwssw', this.resultList)
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 获取年月起止日期之间的数组
    yymmDate(st, ed) {
      let arr = [],len;
      let stDate = new Date(st)
      let edDate = new Date(ed)
      let stY = stDate.getFullYear()
      let stM = stDate.getMonth()
      let edY = edDate.getFullYear()
      let edM = edDate.getMonth()
      len = edM - stM
      let len2 = edY - stY
      if (stY != edY) {
        for (let j = 0; j < len2 + 1; j++) {
          for (let i = 1; i < 13; i++) {
            i = this.fz(i);
            arr.push(stY + j + "-" + i);
          }
        }
        arr.splice(0, stM);
        arr.splice(-(12 - edM - 1), 12 - edM - 1);
        return arr;
      } else {
        for (let i = 1; i < len + 1; i++) {
          i = this.fz(i);
          arr.push(stY + "-" + i);
        }
        arr.push(ed);
        // console.log('arr', arr)
        return arr;
      }
    },
    fz(num) {
      if (num < 10) {
        num = "0" + num;
      }
      return num;
    },
    isNull(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o === "" ||
        o == "null" ||
        o == []
      );
    }
  }
}
</script>
<style scoped>
.sum_search_content{
  display: flex;
  flex-wrap: wrap;
}
.sum_search_box{
  width: 99%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  padding: 15px 0 15px 15px;
  box-sizing: border-box;
}
.sum_search_box .txt01{
  font-size: 14px;
  font-weight: bold;
  margin-right: 10px;
}
.sum_search_box .sum_search_item{
  font-size: 14px;
}
.p_field_box .el-checkbox-group{
  margin-top: 10px;
}
.el-tabs--top {
  width: 99%;
  background-color: #fff;
}
.page_summary .dlt_btn {
  display: flex;
  justify-content: flex-end;
  background: #fff;
  padding: 10px 0 10px 0;
  width: 99%;
}
.dlt_btn .el-button--mini {
  margin-right: 10px;
}
.dlt_btn .el-button--success.is-plain {
  margin-left: 0;
}
.top-right {
  display: flex;
  align-items: center;
}
.top-right .el-button--text {
  padding: 7px 10px;
  border: solid 1px #19bd92;
  font-size: 12px;
  color: #19bd92;
  border-radius: 4px;
  background-color: #fff;
}
.top-right .el-button--text img {
  vertical-align: sub;
}
</style>
<style>
.page_summary .el-table__fixed{
  width: 400px!important;
}
</style>